module.exports = __webpack_public_path__ + "img/sell.d72acb8c.png";